/* RDG — Coups de cœur (22/08/2026).
 *
 * POURQUOI CE FICHIER EXISTE
 * Le tracker maison sait qu'un ajout au panier a été DEMANDÉ, mais pas sur
 * quel produit : il ne relève pas le variantId, et c'est un choix assumé
 * (voir l'en-tête de snippets/rdg-tracker.liquid). Il nous manquait donc un
 * signal de DÉSIR nommé, produit par produit. Le cœur est ce signal — et il
 * rend en même temps un service à la visiteuse, ce qu'un mouchard ne fait pas.
 *
 * OÙ VIT LA LISTE, ET POURQUOI PAS AILLEURS
 * Dans le localStorage de l'appareil, sous `rdg_coeurs`. Pas de compte client,
 * pas de cookie, pas d'identifiant durable envoyé au serveur. C'est la même
 * nature de stockage qu'un panier : la visiteuse range SES choix chez elle, à
 * sa demande. Rien ne part vers nous qui permettrait de la reconnaître d'une
 * visite à l'autre — et c'est ce qui laisse le site sans bandeau de
 * consentement, exactement comme le tracker. Cette contrainte est la raison
 * d'être du fichier, pas un détail d'implémentation : si un jour on pose un
 * identifiant durable ici, il faut ouvrir le dossier consentement en même
 * temps.
 *
 * CE QUE LE DASHBOARD VOIT
 * Deux événements DOM, `rdg:coeur-ajout` et `rdg:coeur-retrait`, portant le
 * handle du produit. snippets/rdg-tracker.liquid les relaie vers
 * tracker_evenements comme n'importe quel geste. On obtient donc « la robe
 * Odette a reçu 34 cœurs cette semaine » — un compteur par produit — sans
 * jamais reconstituer la liste d'une personne.
 *
 * SI CE FICHIER NE SE CHARGE PAS
 * Les boutons cœur restent inertes et le site fonctionne. Aucune étape d'achat
 * ne dépend de lui.
 */
(function () {
  'use strict';
  if (window.__rdgCoeurs) return;
  window.__rdgCoeurs = true;

  var CLE = 'rdg_coeurs';
  var DRAWER_ID = 'RdgCoeursDrawer';

  /* Un plafond, pour deux raisons. Le localStorage d'un domaine tient dans
     quelques mégaoctets partagés avec le reste du thème, et une liste sans
     fin rendrait le tiroir illisible autant que lent (une requête produit par
     ligne). 100 articles, c'est très au-delà de l'usage réel et très en deçà
     de ce qui poserait problème. */
  var MAX = 100;

  /* ------------------------------------------------------------------ */
  /* Le magasin                                                          */
  /* ------------------------------------------------------------------ */

  /* La liste fait autorité EN MÉMOIRE une fois chargée, et le localStorage
     n'en est que la copie durable. La distinction compte en navigation privée
     stricte : Safari accepte la lecture puis refuse l'écriture. Sans mémoire,
     chaque clic serait aussitôt oublié et le cœur clignoterait sans jamais
     rester plein — un bug qui ne se voit que sur l'appareil d'une cliente. */
  var memoire = null;
  var persistant = true;

  function charger() {
    try {
      var brut = localStorage.getItem(CLE);
      var liste = brut ? JSON.parse(brut) : [];
      if (!Array.isArray(liste)) return [];
      /* On filtre à la lecture : un localStorage se modifie à la main, se
         partage entre versions du site, et survit aux refontes. */
      return liste.filter(function (e) {
        return e && typeof e.h === 'string' && e.h.length > 0 && e.h.length < 200;
      }).slice(0, MAX);
    } catch (e) {
      return [];
    }
  }

  function etat() {
    if (memoire === null) memoire = charger();
    return memoire;
  }

  function ranger(liste) {
    memoire = liste.slice(0, MAX);
    try {
      localStorage.setItem(CLE, JSON.stringify(memoire));
    } catch (e) {
      persistant = false;
    }
  }

  function index(handle) {
    var l = etat();
    for (var i = 0; i < l.length; i++) if (l[i].h === handle) return i;
    return -1;
  }

  function contient(handle) { return index(handle) !== -1; }

  /* Les plus récents en tête : le tiroir raconte alors la visite dans l'ordre
     où elle s'est faite, du dernier coup de cœur au premier. */
  function ajouter(handle, titre) {
    if (!handle || contient(handle)) return false;
    var l = etat().slice();
    l.unshift({ h: handle, t: (titre || '').slice(0, 120), d: Date.now() });
    ranger(l);
    annoncer('rdg:coeur-ajout', handle, titre);
    majDOM();
    return true;
  }

  function retirer(handle) {
    var i = index(handle);
    if (i === -1) return false;
    var l = etat().slice();
    var titre = l[i].t;
    l.splice(i, 1);
    ranger(l);
    annoncer('rdg:coeur-retrait', handle, titre);
    majDOM();
    return true;
  }

  function basculer(handle, titre) {
    return contient(handle) ? (retirer(handle), false) : (ajouter(handle, titre), true);
  }

  /* Le seul canal vers la mesure. On envoie le handle et le titre, jamais un
     identifiant de personne — voir l'en-tête. */
  function annoncer(nom, handle, titre) {
    try {
      document.dispatchEvent(new CustomEvent(nom, {
        detail: { handle: handle, titre: titre || '', total: etat().length }
      }));
    } catch (e) {}
  }

  /* ------------------------------------------------------------------ */
  /* Le reflet dans la page                                              */
  /* ------------------------------------------------------------------ */

  function refleter(racine) {
    var boutons = (racine || document).querySelectorAll('[data-rdg-coeur]');
    for (var i = 0; i < boutons.length; i++) {
      var b = boutons[i];
      var actif = contient(b.getAttribute('data-rdg-coeur'));
      b.setAttribute('aria-pressed', actif ? 'true' : 'false');
      b.classList.toggle('is-aime', actif);
      var l = b.getAttribute(actif ? 'data-label-retirer' : 'data-label-ajouter');
      if (l) b.setAttribute('aria-label', l);
    }
  }

  function compteur() {
    var n = etat().length;
    var cibles = document.querySelectorAll('[data-rdg-coeurs-compte]');
    for (var i = 0; i < cibles.length; i++) {
      cibles[i].textContent = n > 0 ? String(n) : '';
      cibles[i].classList.toggle('is-visible', n > 0);
    }
  }

  /* Les vignettes de COLLECTION recoivent la meme bande. Elles sont rendues
     par le serveur, pas par nous : on les prepare au chargement, et de nouveau
     quand le filtrage ou la pagination en pose d'autres (voir l'observateur
     plus bas). */
  function preparerVignettes(racine) {
    var cartes = (racine || document).querySelectorAll('.hdt-card-product');
    for (var i = 0; i < cartes.length; i++) preparerAchat(cartes[i]);
  }

  function majDOM() {
    refleter();
    compteur();
    preparerVignettes();
    /* Le tiroir n'est redessine que s'il est ouvert ; la page, elle, l'est a
       chaque changement — elle EST la liste, elle ne peut pas rester perimee.
       `dessinerPage` sort tout de suite si on n'est pas sur la page. */
    if (ouvert()) dessinerTiroir();
    dessinerPage();
  }

  /* ------------------------------------------------------------------ */
  /* Le rendu des articles                                               */
  /*                                                                     */
  /* LES ARTICLES SONT RENDUS PAR LIQUID, PAS FABRIQUES ICI.             */
  /* On demande a Shopify de rendre une section dans le contexte d'un     */
  /* produit :  /products/<handle>?section_id=rdg-coeur-carte            */
  /* On recupere donc du vrai HTML de theme, avec le vrai objet product.  */
  /*                                                                     */
  /* C'est ce qui permet de reutiliser `rdg-quick-add` tel quel : choix   */
  /* de taille, couleurs, ruptures de stock, ajout au panier et ouverture */
  /* du tiroir sont deja ecrits et valides. Les refaire en JavaScript     */
  /* aurait cree une seconde mecanique d'achat, condamnee a diverger de   */
  /* la premiere des la semaine suivante.                                 */
  /* ------------------------------------------------------------------ */

  var SECTION_CARTE = 'rdg-coeur-carte';   /* la grille de la page   */
  var SECTION_LIGNE = 'rdg-coeur-ligne';   /* les lignes du tiroir   */

  function tiroir() { return document.getElementById(DRAWER_ID); }
  function ouvert() { var d = tiroir(); return !!(d && d.open); }

  function racineRoutes() {
    var r = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return r || '/';
  }

  /* Un article deja demande pendant cette page ne l'est pas deux fois. */
  var cacheHtml = {};

  function htmlArticle(handle, section) {
    var clef = section + '|' + handle;
    if (cacheHtml[clef]) return cacheHtml[clef];
    cacheHtml[clef] = fetch(racineRoutes() + 'products/' + encodeURIComponent(handle) + '?section_id=' + section)
      .then(function (r) {
        if (!r.ok) throw new Error(String(r.status));
        return r.text();
      })
      .catch(function () {
        /* Produit depublie, supprime, ou absent de cette langue. On renvoie
           null plutot que de rejeter : une ligne morte ne doit pas empecher
           les autres de s'afficher. */
        return null;
      });
    return cacheHtml[clef];
  }

  /* L'API de rendu renvoie la section dans son enveloppe `shopify-section`.
     On extrait le noeud utile : sans cela, la grille aurait pour enfants des
     enveloppes vides et ses colonnes ne tomberaient pas en face. */
  function extraire(html, selecteur) {
    if (!html) return null;
    var t = document.createElement('template');
    t.innerHTML = html;
    return t.content.querySelector(selecteur);
  }

  /* Le format monetaire du theme, pour que le total du tiroir soit ecrit
     exactement comme les prix du site. Shopify n'expose que quatre marqueurs ;
     les voici tous les quatre, sinon un changement de format afficherait
     « {{amount}} » en clair. */
  function prix(cents) {
    var fmt = (window.themeHDN && window.themeHDN.settings && window.themeHDN.settings.currencyFormat) || '{{amount}} €';
    var v = (cents || 0) / 100;
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, cle) {
      switch (cle) {
        case 'amount':                      return sep(v, 2, ',', '.');
        case 'amount_no_decimals':           return sep(v, 0, ',', '.');
        case 'amount_with_comma_separator':  return sep(v, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return sep(v, 0, '.', ',');
        default:                             return sep(v, 2, ',', '.');
      }
    });
  }

  function sep(v, decimales, millier, decimal) {
    var s = Math.abs(v).toFixed(decimales);
    var parts = s.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, millier);
    return parts.join(parts.length > 1 ? decimal : '');
  }

  /* Un jeton par dessin et par surface : si la cliente retire un article
     pendant que les articles arrivent, le dessin perime ne doit pas ecraser
     le nouveau. */
  var jetons = {};

  function remplir(conteneur, section, selecteur, apres) {
    if (!conteneur) return;
    var liste = etat();
    if (!liste.length) { conteneur.innerHTML = ''; if (apres) apres([]); return; }

    var cle = section;
    var jeton = (jetons[cle] = (jetons[cle] || 0) + 1);

    Promise.all(liste.map(function (e) { return htmlArticle(e.h, section); })).then(function (htmls) {
      if (jeton !== jetons[cle]) return;

      var morts = [];
      var noeuds = [];
      htmls.forEach(function (html, i) {
        var n = extraire(html, selecteur);
        if (!n) { morts.push(liste[i].h); return; }
        noeuds.push(n);
      });

      conteneur.innerHTML = '';
      noeuds.forEach(function (n) {
        conteneur.appendChild(n);
        /* Apres connexion au document : les elements personnalises du theme
           (<product-form>) ne se reveillent qu'a ce moment-la. */
        preparerAchat(n);
        /* ET ON REFLETE TOUT DE SUITE. Ces cartes arrivent APRES le passage de
           `refleter()` : leur coeur naissait donc vide alors que l'article est,
           par construction, dans la liste — un coeur creux sur la page des
           coups de coeur, ce qui est exactement le contraire de ce qu'elle dit.
           L'observateur de mutations aurait fini par le rattraper, mais il
           passe par requestAnimationFrame, qui ne se declenche pas tant que
           l'onglet est masque : la page pouvait rester fausse indefiniment.
           Un appel direct ne depend de rien. */
        refleter(n);
      });

      /* Un produit disparu du catalogue sort de la liste tout seul : mieux
         vaut une ligne en moins qu'un lien mort vers une 404. */
      if (morts.length) {
        ranger(etat().filter(function (e) { return morts.indexOf(e.h) === -1; }));
        compteur();
      }
      if (apres) apres(noeuds);
    });
  }

  /* ------------------------------------------------------------------ */
  /* LE BOUTON DU PIED : « Voir le panier » tant que rien n'est choisi,   */
  /* « Ajouter au panier (n) » des qu'une taille l'est.                   */
  /*                                                                     */
  /* IL NE DEVIENT JAMAIS INERTE, et c'est le point du dessin. Un bouton  */
  /* grise devant une liste ou l'on n'a encore rien choisi ne dit pas ce  */
  /* qu'il attend ; celui-ci reste utile (il mene au panier) et change    */
  /* d'intention des qu'il a quelque chose a emporter. Le compte est      */
  /* AFFICHE : c'est ce qui empeche la mauvaise surprise d'un pied qui    */
  /* emporterait plus que ce qu'on croit.                                 */
  /* ------------------------------------------------------------------ */
  function choix() {
    var d = tiroir();
    if (!d) return [];
    var lignes = d.querySelectorAll('.rdg-cl');
    var liste = [];
    for (var i = 0; i < lignes.length; i++) {
      var c = lignes[i].__rdgChoix;
      if (c && c.v) liste.push(c);
    }
    return liste;
  }

  function majPied() {
    var d = tiroir();
    if (!d) return;
    var b = d.querySelector('[data-rdg-coeurs-bouton]');
    if (!b) return;
    var n = choix().length;
    var libVoir = b.getAttribute('data-lib-voir') || 'Voir le panier';
    var libAjout = b.getAttribute('data-lib-ajouter') || 'Ajouter au panier';
    b.textContent = n === 0 ? libVoir : libAjout + ' (' + n + ')';
    b.setAttribute('data-rdg', n === 0
      ? 'Coups de cœur — vers le panier (tiroir)'
      : 'Coups de cœur — ajout au panier depuis le pied (tiroir)');
  }

  function messagePied(txt) {
    var d = tiroir();
    if (!d) return;
    var e = d.querySelector('[data-rdg-coeurs-erreur]');
    if (!e) return;
    e.textContent = txt || '';
    e.hidden = !txt;
  }

  /* L'ENVOI. Un SEUL appel a /cart/add.js pour toute la selection, et non un
     par ligne : Shopify traite `items` comme un tout — si une piece part en
     rupture entre l'affichage et le tap, RIEN n'est ajoute et le message le
     dit. Des appels separes laisseraient un panier a moitie rempli, sans
     moyen de savoir lesquels sont passes.

     On n'emprunte PAS le <product-form> du theme ici, contrairement au tap
     d'une taille sur une vignette : il ne sait envoyer qu'une variante, et
     recopier sa mecanique d'evenements (le split de `cart-json`, le nom
     minifie de son evenement de mise a jour) accrocherait ce fichier aux
     entrailles du theme. On poste, puis on va au panier — la page du panier
     lit l'etat reel, elle ne peut pas se tromper. */
  function envoyerAuPanier(bouton) {
    var liste = choix();
    if (!liste.length) return false;
    if (bouton.__rdgEnvoi) return true;      /* double tap : un seul envoi */
    bouton.__rdgEnvoi = true;
    bouton.setAttribute('aria-busy', 'true');
    messagePied('');

    liste.forEach(function (c) {
      try {
        document.dispatchEvent(new CustomEvent('rdg:add-to-cart', {
          detail: { variantId: c.v, label: c.l, source: 'coeurs' }
        }));
      } catch (e) {}
    });

    fetch(racineRoutes() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: liste.map(function (c) { return { id: c.v, quantity: 1 }; })
      })
    }).then(function (r) {
      return r.json().then(function (j) { return { ok: r.ok, corps: j }; });
    }).then(function (res) {
      if (!res.ok) {
        var m = (res.corps && (res.corps.description || res.corps.message)) || '';
        throw new Error(m);
      }
      window.location.href = bouton.getAttribute('href') || (racineRoutes() + 'cart');
    })['catch'](function (err) {
      bouton.__rdgEnvoi = false;
      bouton.removeAttribute('aria-busy');
      messagePied((err && err.message) || "L'ajout n'a pas abouti. Réessayez.");
    });
    return true;
  }

  /* --- Le tiroir (mobile) ------------------------------------------- */
  function dessinerTiroir() {
    var d = tiroir();
    if (!d) return;
    var corps = d.querySelector('[data-rdg-coeurs-liste]');
    var vide  = d.querySelector('[data-rdg-coeurs-vide]');
    var pied  = d.querySelector('[data-rdg-coeurs-pied]');
    if (!corps) return;

    var n = etat().length;
    if (vide) vide.hidden = n > 0;
    if (pied) pied.hidden = n === 0;

    remplir(corps, SECTION_LIGNE, '.rdg-cl', function (noeuds) {
      var reste = etat().length;
      if (vide) vide.hidden = reste > 0;
      if (pied) pied.hidden = reste === 0;

      /* Le compte et le total, comme la reference. Le total est la somme des
         prix affiches : c'est un ordre de grandeur de ce que la liste
         represente, pas un panier — rien n'est reserve et aucune taille n'est
         choisie.

         DEUX CASES DEPUIS LE 28/08, et non plus une seule chaine. Le pied du
         tiroir a ete refait sur la reference : le compte est cale a gauche, le
         total a droite, ce qui demande deux elements a placer et non un texte
         « 1 article · 49,00€ » que le CSS ne pourrait pas separer.

         Chacune est ecrite independamment et gardee par son propre `if` : si
         un jour le pied ne portait plus qu'une des deux, l'autre continuerait
         de fonctionner au lieu de faire tomber la fonction. */
      var total = 0;
      noeuds.forEach(function (n) { total += Number(n.getAttribute('data-prix') || 0); });
      /* `-pied-` dans les deux noms : `data-rdg-coeurs-compte` tout court est
         le crochet des PASTILLES de l'en-tete, que `compteur()` remplit par un
         `document.querySelectorAll` sans se borner au tiroir. Une case du pied
         qui porterait ce nom afficherait le nombre nu (« 2 ») a la place de
         « 2 articles », ecrase a chaque changement de la liste. */
      var elCompte = d.querySelector('[data-rdg-coeurs-pied-compte]');
      var elTotal  = d.querySelector('[data-rdg-coeurs-pied-total]');
      if (elCompte) {
        elCompte.textContent = reste > 0
          ? reste + (reste > 1 ? ' articles' : ' article')
          : '';
      }
      if (elTotal) elTotal.textContent = reste > 0 ? prix(total) : '';

      /* Les lignes viennent d'etre reconstruites : aucun choix ne survit a un
         redessin, le bouton doit donc repartir de « Voir le panier » et le
         message d'erreur d'un envoi precedent disparaitre. */
      messagePied('');
      majPied();
    });
  }

  /* --- La page (desktop) -------------------------------------------- */
  function dessinerPage() {
    var grille = document.querySelector('[data-rdg-coeurs-grille]');
    if (!grille) return;
    var vide = document.querySelector('[data-rdg-coeurs-vide-page]');
    var note = document.querySelector('[data-rdg-coeurs-note-page]');
    var cpt  = document.querySelector('[data-rdg-coeurs-compte-page]');

    function etats(n) {
      if (vide) vide.hidden = n > 0;
      if (note) note.hidden = n === 0;
      if (cpt) {
        cpt.hidden = n === 0;
        cpt.textContent = n + (n > 1 ? ' articles' : ' article');
      }
    }
    etats(etat().length);
    remplir(grille, SECTION_CARTE, '.rdg-cc', function () { etats(etat().length); });
  }

  /* ------------------------------------------------------------------ */
  /* Le choix de taille, DANS la carte                                   */
  /*                                                                     */
  /* Lucien, 22/08, deuxieme passe (reference type Zara) : les tailles ne */
  /* sont plus derriere un bouton « Ajouter », elles APPARAISSENT AU      */
  /* SURVOL DE L'IMAGE, en bande, avec un trait fin sous celle survolee.  */
  /* Un geste au lieu de deux — et cela supprime au passage le defaut     */
  /* signale (« impossible de cliquer sur les variantes de tailles ») :   */
  /* il n'y a plus de declencheur pose par-dessus la bande.               */
  /*                                                                     */
  /* ON NE REECRIT PAS L'ACHAT POUR AUTANT. On lit les MEMES donnees que  */
  /* le panneau modal — `data-rdg-sizes`, `data-rdg-colors`,              */
  /* `data-rdg-form`, posees par snippets/rdg-quick-add.liquid — et on    */
  /* termine comme lui : renseigner l'input `id` du <product-form> puis   */
  /* cliquer son bouton d'envoi cache. Le theme fait l'ajout AJAX, ouvre  */
  /* le tiroir panier et gere les erreurs. Seule la PRESENTATION change.  */
  /* C'est aussi pour cela que la detection de l'option « taille », des   */
  /* couleurs et des ruptures n'est pas dupliquee : elle est deja faite   */
  /* en Liquid, en amont.                                                 */
  /* ------------------------------------------------------------------ */

  function lireJson(txt) {
    try { return txt ? JSON.parse(txt) : null; } catch (e) { return null; }
  }

  /* 16/09/2026 — Le style des pastilles de la bande, pose UNE fois, ici.
     Il accompagne le seul code qui cree ces pastilles : une retouche = un
     fichier a deployer, et le theme live n'a pas de brouillon. Memes
     mesures que .rdg-sheet__size--pastille (avenir-next.css) : rectangle
     50x20, liseré de la palette ; le trait fin du survol et le barre de
     l'epuise, eux, reprennent le langage des tailles de la bande. */
  function styleDesPastilles() {
    if (document.getElementById('rdg-achat-pastilles')) return;
    var s = document.createElement('style');
    s.id = 'rdg-achat-pastilles';
    s.textContent =
      '.rdg-achat__taille--pastille{position:relative;display:inline-flex;align-items:center;padding:.5rem .2rem}' +
      '.rdg-achat__taille--pastille>span{display:block;width:50px;height:20px;background:var(--rdg-pastille,transparent);border:1px solid var(--line)}' +
      '.rdg-achat__taille--pastille::after{content:"";position:absolute;left:.2rem;right:.2rem;bottom:0;height:1px;background:currentColor;opacity:0}' +
      '.rdg-achat__taille--pastille:hover:not([disabled])::after,.rdg-achat__taille--pastille:focus-visible::after,.rdg-achat__taille--pastille.is-ajoute::after{opacity:1}' +
      '.rdg-achat__taille--pastille.is-epuise::before{content:"";position:absolute;left:0;right:0;top:50%;height:1px;background:currentColor}' +
      '.rdg-achat__tailles:has(.rdg-achat__taille--pastille){gap:.4rem 1.2rem}';
    document.head.appendChild(s);
  }

  /* 17/10/2026 — LA PHOTO DU COLORIS, AUSSI DANS LA BANDE DU SURVOL.
     Lucien : « quand une variante est sélectionnée, afficher les autres
     couleurs ». Le panneau du « + » (rdg-size-sheet.js, apercu(), 02/10) pose
     déjà la photo du coloris choisi sur la vignette ; la bande de l'ordinateur,
     elle, redessinait les tailles et laissait la photo du premier coloris.
     Même couche (`.rdg-apercu`, avenir-next.css), même principe : posée
     par-dessus `.hdt-card-product__media`, jamais à la place de l'image (la
     vignette est un carrousel), préchargée avant d'être montrée, retirée quand
     on revient au premier coloris ou quand la souris quitte la carte — la
     grille revient alors exactement à ce qu'elle était. Ici une seule photo :
     la bande n'a pas de geste pour faire défiler une série. */
  function apercuCarte(article, url) {
    var media = article.querySelector('.hdt-card-product__media');
    if (!media) return;
    var c = media.querySelector(':scope > .rdg-apercu');
    if (!url) {
      if (c) {
        c.removeAttribute('data-rdg-src');
        c.classList.remove('is-visible');
        setTimeout(function () { if (c.parentNode && !c.getAttribute('data-rdg-src')) c.parentNode.removeChild(c); }, 400);
      }
      return;
    }
    if (c && c.getAttribute('data-rdg-src') === url) return;
    if (!c) {
      c = document.createElement('div');
      c.className = 'rdg-apercu';
      c.setAttribute('aria-hidden', 'true');
      media.appendChild(c);
    }
    c.setAttribute('data-rdg-src', url);
    var pre = new Image();
    pre.onload = function () {
      if (c.getAttribute('data-rdg-src') !== url) return;  /* un autre coloris a été choisi entre-temps */
      var piste = document.createElement('div');
      piste.className = 'rdg-apercu__piste';
      var img = document.createElement('img');
      img.alt = '';
      img.decoding = 'async';
      img.src = url;
      piste.appendChild(img);
      c.textContent = '';
      c.appendChild(piste);
      c.classList.add('is-visible');
    };
    pre.src = url;
  }

  /* Le coloris dont la photo est celle que la vignette affiche (même nom de
     fichier, adresse sans ses paramètres) ; 0 si aucun ne correspond. */
  function coloriDeLaPhoto(article, couleurs) {
    var img = article.querySelector('.hdt-card-product__media--main');
    var nom = function (u) { return (u || '').split('?')[0].split('/').pop(); };
    var vu = img ? nom(img.getAttribute('src') || img.currentSrc) : '';
    if (!vu) return 0;
    for (var k = 0; k < couleurs.length; k++) {
      if (couleurs[k].i && nom(couleurs[k].i) === vu) return k;
    }
    return 0;
  }

  function preparerAchat(article) {
    if (!article || article.__rdgAchat) return;
    var trig = article.querySelector('.rdg-qa__trigger[data-rdg-sizes]');
    if (!trig) return;               /* taille unique ou epuise : rien a deplier */
    article.__rdgAchat = true;

    var tailles = lireJson(trig.getAttribute('data-rdg-sizes')) || [];
    var couleurs = lireJson(trig.getAttribute('data-rdg-colors'));
    var formId = trig.getAttribute('data-rdg-form');
    if (!tailles.length) return;

    /* CE NE SONT PAS TOUJOURS DES TAILLES.
       Quand un produit n'a pas d'option « taille », rdg-quick-add retombe sur
       sa derniere option — souvent la couleur. C'est volontaire : il faut bien
       choisir quelque chose pour ajouter au panier. Mais une bande NUE, sans
       titre, ne peut pas dire ce qu'elle montre : « WINE » pose la ou on
       attend « S M L » se lit comme une taille.

       On lit `data-rdg-is-size`, pose par le snippet, plutot que de
       redecouvrir ici ce qu'est une taille : la detection s'appuie sur la
       liste de correspondance du theme, et la dupliquer ferait diverger les
       deux au premier ajout de valeur. Mesure de la session refonte sur NEW
       IN : 26 declencheurs, 3 qui ne sont pas des tailles.

       Sur une VIGNETTE DE COLLECTION on renonce alors a la bande : le « + »
       reste, et son panneau se titre « Choisir une option ». Sur la page des
       coups de coeur et dans le tiroir, la bande est le seul chemin — on la
       garde, mais on la titre avec le nom reel de l'option. */
    var estTaille = trig.getAttribute('data-rdg-is-size') !== 'false';
    var surVignette = article.classList.contains('hdt-card-product');
    /* 16/09/2026 — SAUF QUAND CE SONT DES COULEURS, ET QU'ON LE VOIT.
       Lucien, sur les sacs (seule option : Couleur) : le « + » du telephone
       restait en PC, « ce qui n'a aucun sens », la ou les autres vignettes
       montrent leurs tailles au survol. Le renoncement ci-dessous visait une
       bande NUE qui ferait lire « WINE » comme une taille. Quand CHAQUE valeur
       porte sa pastille (`c`, posee par rdg-quick-add depuis la palette), la
       bande dessine des rectangles de couleur sous l'intitule « Couleur » :
       plus rien ne se confond avec une taille. On ne renonce donc plus que si
       une valeur n'a pas de pastille. */
    var toutesPastilles = tailles.every(function (t) { return !!t.c; });
    if (!estTaille && surVignette && !toutesPastilles) return;

    /* DANS LE TIROIR, LA BANDE NE SERT PLUS A AJOUTER : ELLE SERT A CHOISIR.
       Demande de Lucien du 28/08, apres coup — c'est le modele de la
       reference (on choisit la variante sur la ligne, un bouton unique en bas
       envoie tout au panier) que la premiere passe avait ecarte.

       LE CHANGEMENT EST BORNE AU TIROIR, ET C'EST DELIBERE. La meme bande est
       posee sur les VIGNETTES DE COLLECTION (au survol, en PC) et sur les
       cartes de la PAGE des coups de cœur — deux surfaces qui n'ont AUCUN
       bouton en pied pour finir le geste. Y transformer l'ajout en simple
       selection laisserait un choix sans aucun moyen de le valider : la
       collection perdrait son ajout rapide, c'est-a-dire l'essentiel du
       trafic. Elles gardent donc le tap qui ajoute. */
    var dansTiroir = article.classList.contains('rdg-cl');

    /* PAS DE BANDE DANS LES CARROUSELS — Lucien, 25/08 : « le + en haut a
       droite de l'image » dans « vous aimerez aussi ». Une bande de tailles
       demande de la largeur ; ces vignettes font 177px contre 419 en grille de
       collection, et les tailles s'y empileraient sur deux lignes.

       On laisse donc le « + » et son panneau tenir ces surfaces, a toutes les
       largeurs. Comme la classe `a-tailles` n'est jamais posee ici, la regle
       qui masque le « + » en PC ne s'applique pas non plus : il reste visible
       partout, sans qu'aucune regle supplementaire soit necessaire.

       « Avoir le look » n'est pas affecte : son declencheur est le FRERE de la
       carte et non son descendant, donc aucune bande n'y a jamais ete
       construite (verifie : 1 declencheur avec tailles, 0 bande). */
    if (article.closest('.hdt-slider__slide')) return;

    var hote = article.querySelector('[data-rdg-achat-hote]');
    function libelle(nom, defaut) {
      return (hote && hote.getAttribute(nom)) || article.getAttribute(nom) || defaut;
    }
    var lib = {
      ajouter: libelle('data-lib-ajouter', 'Ajouter'),
      ajoute:  libelle('data-lib-ajoute',  'Ajouté')
    };

    /* LE DECLENCHEUR S'EFFACE — MAIS ON NE LE DESARME PAS.
       C'est une correction du 22/08, et le defaut qu'elle repare valait cher :
       je lui retirais `aria-controls` pour l'empecher d'ouvrir le panneau
       modal par-dessus la bande. Utile dans le modele precedent, ou il restait
       VISIBLE et cliquable. Avec la bande au survol il ne l'est plus en PC
       (`display: none`) — en revanche il reste le SEUL chemin au doigt, ou la
       bande est masquee. Le desarmer rendait donc 23 vignettes sur 29
       inertes sur telephone, silencieusement : le « + » etait la, il ne
       faisait rien. Mesure du 22/08 : `aria-controls` a null, panneau qui ne
       s'ouvre pas.

       On se contente donc de la classe, et `display: none` fait le reste : il
       sort tout seul du parcours clavier et de l'arbre d'accessibilite. Pas de
       `tabindex="-1"` ni d'`aria-hidden` non plus — ils rendraient le bouton
       inatteignable au clavier et muet a la synthese vocale LA OU IL SERT,
       c'est-a-dire au doigt. */
    trig.classList.add('rdg-qa--efface');

    var panneau = document.createElement('div');
    panneau.className = 'rdg-achat';
    if (!estTaille) {
      var intitule = document.createElement('p');
      intitule.className = 'rdg-achat__intitule';
      intitule.textContent = trig.getAttribute('data-rdg-option') || '';
      if (intitule.textContent) panneau.appendChild(intitule);
    }

    var rangeeCouleurs = null;
    /* 17/10 (soir) — LE COLORIS DE DEPART EST CELUI DE LA PHOTO, PAS LE PREMIER.
       Lucien : « quand on choisit une variante, l'autre n'apparaît pas ».
       Le code tenait le coloris n° 0 pour celui de la photo de la vignette, et
       « revenir au n° 0 » pour « retirer l'aperçu ». Faux dès que la photo
       principale est celle d'un autre coloris : ROBE MÉLUSINE montre BEIGE,
       sa liste commence par WINE ; cliquer WINE ramenait la photo… beige.
       On cherche donc le coloris dont la photo (`i`) est l'image affichée
       (même fichier) ; à défaut, le n° 0 comme avant. */
    var iDepart = couleurs && couleurs.length > 1 ? coloriDeLaPhoto(article, couleurs) : 0;
    var iCouleur = iDepart;
    if (couleurs && couleurs.length > 1) {
      rangeeCouleurs = document.createElement('div');
      rangeeCouleurs.className = 'rdg-achat__couleurs';
      couleurs.forEach(function (c, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'rdg-achat__couleur';
        b.textContent = c.l;
        b.setAttribute('aria-pressed', i === iDepart ? 'true' : 'false');
        b.addEventListener('click', function () {
          iCouleur = i;
          [].forEach.call(rangeeCouleurs.children, function (autre, j) {
            autre.setAttribute('aria-pressed', j === i ? 'true' : 'false');
          });
          /* CHANGER DE COULEUR ANNULE LA TAILLE CHOISIE, dans le tiroir.
             `dessinerTailles()` reconstruit la rangee : les boutons d'avant
             n'existent plus, et la variante retenue appartenait a l'ancien
             coloris. La garder enverrait au panier une piece d'une couleur que
             la cliente vient justement de quitter. */
          if (dansTiroir) { article.__rdgChoix = null; }
          dessinerTailles();
          if (dansTiroir) majPied();
          if (surVignette) apercuCarte(article, i === iDepart ? null : (c.i || null));
        });
        rangeeCouleurs.appendChild(b);
      });
      panneau.appendChild(rangeeCouleurs);
      /* La souris quitte la carte : retour au premier coloris et à la photo
         d'origine, sinon la carte garderait un coloris que la bande, au
         prochain survol, ne montrerait plus comme choisi. */
      if (surVignette) {
        article.addEventListener('mouseleave', function () {
          if (iCouleur === iDepart) return;
          iCouleur = iDepart;
          [].forEach.call(rangeeCouleurs.children, function (autre, j) {
            autre.setAttribute('aria-pressed', j === iDepart ? 'true' : 'false');
          });
          dessinerTailles();
          apercuCarte(article, null);
        });
      }
    }

    var rangeeTailles = document.createElement('div');
    rangeeTailles.className = 'rdg-achat__tailles';
    panneau.appendChild(rangeeTailles);

    function listeCourante() {
      if (couleurs && couleurs.length > 1) return (couleurs[iCouleur] || {}).s || [];
      return tailles;
    }

    function dessinerTailles() {
      rangeeTailles.innerHTML = '';
      listeCourante().forEach(function (t) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'rdg-achat__taille';
        if (t.c) {
          /* 16/09 — UNE COULEUR SE MONTRE (meme regle que le panneau du « + »,
             rdg-size-sheet.js) : le rectangle 50x20 de la palette, le NOM en
             nom accessible et en infobulle. */
          styleDesPastilles();
          b.className += ' rdg-achat__taille--pastille';
          b.style.setProperty('--rdg-pastille', t.c);
          b.setAttribute('aria-label', t.l + (!t.a || !t.v ? ' (épuisé)' : ''));
          b.title = t.l;
          b.appendChild(document.createElement('span'));
        } else {
          b.textContent = t.l;
        }
        if (!t.a || !t.v) {
          /* Une taille indisponible reste AFFICHEE et barree, jamais retiree :
             savoir qu'elle existe et qu'elle manque n'est pas la meme
             information que ne pas la voir du tout. */
          b.disabled = true;
          b.classList.add('is-epuise');
        } else if (dansTiroir) {
          /* On CHOISIT. Rien ne part au panier : c'est le bouton du pied qui
             envoie, et lui seul. `aria-pressed` plutot qu'une classe seule —
             c'est ce que la rangee de couleurs fait deja juste au-dessus, et
             c'est ce qu'une synthese vocale sait lire. */
          b.setAttribute('aria-pressed', 'false');
          b.addEventListener('click', function () { choisir(t, b); });
        } else {
          b.addEventListener('click', function () { ajouterAuPanier(t, b); });
        }
        rangeeTailles.appendChild(b);
      });
      /* UNE SEULE TAILLE DISPONIBLE : ON NE LA PRE-CHOISIT PAS.
         La reference le ferait — son menu deroulant s'affiche deja rempli, et
         « tout ajouter » emporte donc la piece sans qu'on l'ait touchee. On
         s'en ecarte volontairement : avec plusieurs articles en liste, un pied
         qui emporte des pieces jamais designees est une mauvaise surprise a la
         caisse. Ce qui part au panier est ce qu'on a touche, sans exception —
         et le bouton du pied annonce le compte, de sorte qu'il n'y a jamais de
         doute sur ce qu'il emporte. */
    }

    /* Le choix vit sur la LIGNE (`article.__rdgChoix`), pas dans une variable
       de module : chaque ligne a son propre panneau, et le pied les relit
       toutes au moment d'envoyer. Un choix par ligne, jamais deux. */
    function choisir(t, bouton) {
      var deja = bouton.getAttribute('aria-pressed') === 'true';
      [].forEach.call(rangeeTailles.children, function (autre) {
        autre.setAttribute('aria-pressed', 'false');
      });
      if (deja) {
        /* Retaper la taille deja choisie la DESELECTIONNE. Sans cela on ne
           pourrait plus revenir en arriere sans fermer le tiroir, et le pied
           emporterait un article qu'on ne veut plus. */
        article.__rdgChoix = null;
      } else {
        bouton.setAttribute('aria-pressed', 'true');
        article.__rdgChoix = { v: t.v, l: t.l };
      }
      majPied();
    }

    function ajouterAuPanier(t, bouton) {
      var form = document.getElementById(formId);
      if (!form) return;
      var input = form.querySelector('input[name="id"]');
      var envoi = form.querySelector('[data-rdg-submit]');
      if (!input || !envoi) return;

      /* Le meme evenement que celui du panneau modal, avec sa propre source :
         sans lui, les ajouts partis des coups de coeur seraient absents de la
         mesure alors que ceux de la fiche produit y sont. `source` permet de
         les distinguer dans le dashboard. Emis AVANT l'envoi, comme le sheet :
         il dit qu'un ajout a ete DEMANDE, pas qu'il a abouti. */
      try {
        document.dispatchEvent(new CustomEvent('rdg:add-to-cart', {
          detail: { variantId: t.v, label: t.l, source: 'coeurs' }
        }));
      } catch (e) {}

      input.value = t.v;
      envoi.click();

      /* Une pastille n'a pas de texte a remplacer : on ne touche qu'au
         souligne (is-ajoute), sans quoi « Ajouté » effacerait le rectangle. */
      var pastille = bouton.classList.contains('rdg-achat__taille--pastille');
      var avant = bouton.textContent;
      if (!pastille) bouton.textContent = lib.ajoute;
      bouton.classList.add('is-ajoute');
      setTimeout(function () {
        if (!pastille) bouton.textContent = avant;
        bouton.classList.remove('is-ajoute');
      }, 2200);
    }

    dessinerTailles();

    /* La bande se pose dans la zone d'actions, pas apres l'image : c'est ce
       qui la fait apparaitre SUR la photo comme dans la reference. */
    (hote || trig.parentElement).appendChild(panneau);

    /* Plus aucun ecouteur sur le declencheur : c'est le CSS, au survol de la
       vignette, qui montre la bande. Une interaction de moins a maintenir, et
       surtout plus rien qui se superpose aux tailles. */
    article.classList.add('a-tailles');
  }

  /* ------------------------------------------------------------------ */
  /* Les gestes                                                          */
  /* ------------------------------------------------------------------ */

  /* Un seul écouteur délégué, en phase de capture : il attrape aussi les cartes
     posées après coup par le filtrage de collection ou la pagination infinie,
     sans jamais avoir à se rebrancher. */
  document.addEventListener('click', function (ev) {
    var el = ev.target && ev.target.closest ? ev.target.closest('[data-rdg-coeur],[data-rdg-coeur-retirer]') : null;
    if (!el) return;

    var retrait = el.hasAttribute('data-rdg-coeur-retirer');
    var handle = el.getAttribute(retrait ? 'data-rdg-coeur-retirer' : 'data-rdg-coeur');
    if (!handle) return;

    /* Le cœur est posé SUR la vignette, à côté du lien produit : sans ces deux
       lignes, aimer un article ouvrirait sa fiche dans la foulée. */
    ev.preventDefault();
    ev.stopPropagation();

    if (retrait) retirer(handle);
    else basculer(handle, el.getAttribute('data-rdg-titre'));
  }, true);

  /* « VOIR LE PANIER » OUVRE LE TIROIR, PAS LA PAGE — Lucien, 28/08 au soir.
     C'est le meme raisonnement que celui qui a fait garder le tiroir comme
     chemin principal des coups de cœur : un tiroir ne recharge pas la page. La
     cliente garde sa position, jette un œil a son panier, referme, et reprend
     ou elle en etait. L'envoyer sur /cart, c'etait une navigation et un retour
     arriere a faire au milieu d'un achat.

     ON FERME D'ABORD LE TIROIR DES COUPS DE CŒUR. Deux panneaux empiles l'un
     sur l'autre laisseraient la cliente avec deux croix a fermer pour revenir a
     la collection, et sans savoir laquelle ferme quoi.

     L'ELEMENT RESTE UN <a href="/cart"> ET LE LIEN RESTE VALIDE : si le tiroir
     panier n'est pas sur la page, ou si son element personnalise n'est pas
     reveille, `ouvrirTiroirPanier` renvoie false et le clic suit le lien. On ne
     remplace pas une destination sure par une destination conditionnelle. */
  function ouvrirTiroirPanier() {
    var d = document.getElementById('CartDrawer');
    var hote = d && d.parentElement;
    if (!hote || typeof hote.open !== 'function') return false;
    var t = tiroir();
    if (t && t.open) { try { t.close(); } catch (e) {} }
    hote.open();
    return true;
  }

  document.addEventListener('click', function (ev) {
    var b = ev.target && ev.target.closest ? ev.target.closest('[data-rdg-coeurs-bouton]') : null;
    if (!b) return;
    /* Une selection en attente : on envoie au panier, et cette voie-la mene
       toujours a la PAGE panier. Ce n'est pas un oubli — apres un ajout, le
       tiroir deja rendu est perime, et le rafraichir demande de reconstruire
       ce que le theme fait lui-meme au moment de l'ajout. La page, elle, lit
       l'etat reel : elle ne peut pas se tromper. */
    if (envoyerAuPanier(b)) { ev.preventDefault(); return; }
    /* Rien de choisi : le bouton dit « Voir le panier », et il montre le
       panier sans quitter la page. */
    if (ouvrirTiroirPanier()) ev.preventDefault();
  });

  /* Le tiroir se remplit à l'ouverture, pas au chargement de la page : tant
     qu'on ne l'ouvre pas, il ne coûte aucune requête. */
  document.addEventListener('click', function (ev) {
    var t = ev.target && ev.target.closest ? ev.target.closest('[aria-controls="' + DRAWER_ID + '"]') : null;
    if (t) dessinerTiroir();
  }, true);

  /* Deux onglets ouverts sur la boutique, c'est courant quand on compare deux
     articles. L'événement `storage` n'arrive que dans les AUTRES onglets : on
     y recharge la liste plutôt que de laisser un cœur mentir. */
  window.addEventListener('storage', function (ev) {
    if (ev.key && ev.key !== CLE) return;
    memoire = null;
    majDOM();
  });

  /* Les cartes arrivent aussi après coup (filtres, « voir plus »). On ne
     re-parcourt la page que si la mutation a réellement apporté un cœur —
     sinon un observateur posé sur tout le document coûterait à chaque frame
     d'animation. */
  var prevu = false;
  new MutationObserver(function (mutations) {
    if (prevu) return;
    for (var i = 0; i < mutations.length; i++) {
      var ajouts = mutations[i].addedNodes;
      for (var j = 0; j < ajouts.length; j++) {
        var n = ajouts[j];
        if (n.nodeType !== 1) continue;
        if (n.hasAttribute('data-rdg-coeur') || (n.querySelector && n.querySelector('[data-rdg-coeur]'))) {
          prevu = true;
          requestAnimationFrame(function () { prevu = false; refleter(); preparerVignettes(); });
          return;
        }
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

  /* L'API publique, pour la fiche produit et pour la console pendant les
     essais. Volontairement minuscule : tout le reste est du détail interne. */
  window.rdgCoeurs = {
    liste: function () { return etat().slice(); },
    contient: contient,
    ajouter: ajouter,
    retirer: retirer,
    basculer: basculer,
    compte: function () { return etat().length; },
    persistant: function () { return persistant; }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', majDOM);
  } else {
    majDOM();
  }
})();
